export default __webpack_public_path__ + "static/media/R_Raposa.a4384d44.svg";